import PaginatedList from '@theme/paginated-list';

/**
 * A custom element that renders a paginated blog posts list.
 * Extends PaginatedList with a fallback: if data-last-page is not set on the
 * grid (due to Shopify section rendering constraints), we default it to a safe
 * large value so the infinite scroll continues to work.
 */
export default class BlogPostsList extends PaginatedList {
  connectedCallback() {
    const grid = this.querySelector('[ref="grid"]');
    if (grid && (!grid.dataset.lastPage || grid.dataset.lastPage === '0')) {
      // Fallback: set a high last-page so the JS keeps trying to load more.
      // It will naturally stop when a page returns no articles.
      grid.dataset.lastPage = '999';
    }
    super.connectedCallback();
  }
}

if (!customElements.get('blog-posts-list')) {
  customElements.define('blog-posts-list', BlogPostsList);
}
